// extracted by mini-css-extract-plugin
export default {"menu":"ActivityTemplateMenu_menu__ZkHIs"};